<ng-container *ngIf="viewModel$ | async as viewModel">
	<app-form-schema-renderer [property]="[]" [schema]="viewModel.schema" [data]="viewModel.user" [readonly]="false"
							(emitFormSubmit)="saveUser($event, viewModel.user)" [formID]="userFormId"
							(emitFormValid)="userEditSplitButton.disabled = !$event">
	</app-form-schema-renderer>
</ng-container>
<div class="toolbar">
	<app-splitbutton [elements]="[userCancelSplitButton]"></app-splitbutton>
	<app-splitbutton [elements]="[userEditSplitButton]"></app-splitbutton>
</div>